import type { CarrierConfig } from '../../../domain/types/configs/company/CarrierConfig';

export const carriersConfig: CarrierConfig = {
  transporters: [
    {
      isActived: true,
      visible: true,
      label: "AGILITY LOGISTICS",
      trackCarrier: "AGL",
      value: "A1"
    },
    {
      isActived: true,
      visible: true,
      label: "ALLIANCE TRANSPORT LOGISTICS",
      trackCarrier: "ATL",
      value: "A2"
    },
    {
      isActived: true,
      visible: true,
      label: "CEVA LOGISTICS",
      trackCarrier: "CEVA",
      value: "C1"
    },
    {
      isActived: true,
      visible: true,
      label: "CH ROBINSON",
      trackCarrier: "CHR",
      value: "C2"
    },
    {
      isActived: true,
      visible: true,
      label: "DAMCO",
      trackCarrier: "DAM",
      value: "D1"
    },
    {
      isActived: true,
      visible: true,
      label: "DB SCHENKER",
      trackCarrier: "DBS",
      value: "D2"
    },
    {
      isActived: true,
      visible: true,
      label: "DHL EXPRESS",
      trackCarrier: "DHLX",
      value: "D3"
    },
    {
      isActived: true,
      visible: true,
      label: "DHL GLOBAL FORWARDING",
      trackCarrier: "DHGF",
      value: "D4"
    },
    {
      isActived: true,
      visible: true,
      label: "DSV",
      trackCarrier: "DSV",
      value: "D5"
    },
    {
      isActived: true,
      visible: true,
      label: "EXPEDITORS INTERNATIONAL",
      trackCarrier: "EXP",
      value: "E1"
    },
    {
      isActived: true,
      visible: true,
      label: "FEDEX (CARGA)",
      trackCarrier: "FDXC",
      value: "F1"
    },
    {
      isActived: true,
      visible: true,
      label: "FEDEX (COURIER)",
      trackCarrier: "FDX",
      value: "F2"
    },
    {
      isActived: true,
      visible: true,
      label: "GEODIS",
      trackCarrier: "GEO",
      value: "G1"
    },
    {
      isActived: true,
      visible: true,
      label: "HELLMAN WORLDWILDE LOGISTICS",
      trackCarrier: "HWL",
      value: "H1"
    },
    {
      isActived: true,
      visible: true,
      label: "KERRY LOGISTICS",
      trackCarrier: "KERRY",
      value: "K1"
    },
    {
      isActived: true,
      visible: true,
      label: "KINTETSU WORLD EXPRESS",
      trackCarrier: "KWE",
      value: "K2"
    },
    {
      isActived: true,
      visible: true,
      label: "KUEHNE+NAGEL",
      trackCarrier: "KN",
      value: "K3"
    },
    {
      isActived: true,
      visible: true,
      label: "LO TRADING",
      trackCarrier: "LO",
      value: "L1"
    },
    {
      isActived: true,
      visible: true,
      label: "MAGNUM LOGISTICS",
      trackCarrier: "MAG",
      value: "M1"
    },
    {
      isActived: true,
      visible: true,
      label: "NIPPON EXPRESS",
      trackCarrier: "NEX",
      value: "N1"
    },
    {
      isActived: true,
      visible: true,
      label: "NISSIN CORPORATION",
      trackCarrier: "NISS",
      value: "N2"
    },
    {
      isActived: true,
      visible: true,
      label: "PANALPINA",
      trackCarrier: "PAN",
      value: "P1"
    },
    {
      isActived: true,
      visible: true,
      label: "TOLL GROUP",
      trackCarrier: "TOLL",
      value: "T1"
    },
    {
      isActived: true,
      visible: true,
      label: "UPS (COURIER)",
      trackCarrier: "UPSC",
      value: "U1"
    },
    {
      isActived: true,
      visible: true,
      label: "UPS (FREIGHT)",
      trackCarrier: "UPSF",
      value: "U2"
    },
    {
      isActived: true,
      visible: true,
      label: "VANGUARD MEDICAL LOGISTICS",
      trackCarrier: "VML",
      value: "V1"
    },
    {
      isActived: true,
      visible: true,
      label: "YUSEN LOGISTICS",
      trackCarrier: "YUS",
      value: "Y1"
    }
  ],
  payTo: [
    {
      isActived: true,
      visible: true,
      label: "AGILITY LOGISTICS",
      trackCarrier: "AGL",
      value: "A1"
    },
    {
      isActived: true,
      visible: true,
      label: "ALLIANCE TRANSPORT LOGISTICS",
      trackCarrier: "ATL",
      value: "A2"
    },
    {
      isActived: true,
      visible: true,
      label: "CEVA LOGISTICS",
      trackCarrier: "CEVA",
      value: "C1"
    },
    {
      isActived: true,
      visible: true,
      label: "CH ROBINSON",
      trackCarrier: "CHR",
      value: "C2"
    },
    {
      isActived: true,
      visible: true,
      label: "DAMCO",
      trackCarrier: "DAM",
      value: "D1"
    },
    {
      isActived: true,
      visible: true,
      label: "DB SCHENKER",
      trackCarrier: "DBS",
      value: "D2"
    },
    {
      isActived: true,
      visible: true,
      label: "DHL EXPRESS",
      trackCarrier: "DHLX",
      value: "D3"
    },
    {
      isActived: true,
      visible: true,
      label: "DHL GLOBAL FORWARDING",
      trackCarrier: "DHGF",
      value: "D4"
    },
    {
      isActived: true,
      visible: true,
      label: "DSV",
      trackCarrier: "DSV",
      value: "D5"
    },
    {
      isActived: true,
      visible: true,
      label: "EXPEDITORS INTERNATIONAL",
      trackCarrier: "EXP",
      value: "E1"
    },
    {
      isActived: true,
      visible: true,
      label: "FEDEX (CARGA)",
      trackCarrier: "FDXC",
      value: "F1"
    },
    {
      isActived: true,
      visible: true,
      label: "FEDEX (COURIER)",
      trackCarrier: "FDX",
      value: "F2"
    },
    {
      isActived: true,
      visible: true,
      label: "GEODIS",
      trackCarrier: "GEO",
      value: "G1"
    },
    {
      isActived: true,
      visible: true,
      label: "HELLMAN WORLDWILDE LOGISTICS",
      trackCarrier: "HWL",
      value: "H1"
    },
    {
      isActived: true,
      visible: true,
      label: "KERRY LOGISTICS",
      trackCarrier: "KERRY",
      value: "K1"
    },
    {
      isActived: true,
      visible: true,
      label: "KINTETSU WORLD EXPRESS",
      trackCarrier: "KWE",
      value: "K2"
    },
    {
      isActived: true,
      visible: true,
      label: "KUEHNE+NAGEL",
      trackCarrier: "KN",
      value: "K3"
    },
    {
      isActived: true,
      visible: true,
      label: "LO TRADING",
      trackCarrier: "LO",
      value: "L1"
    },
    {
      isActived: true,
      visible: true,
      label: "MAGNUM LOGISTICS",
      trackCarrier: "MAG",
      value: "M1"
    },
    {
      isActived: true,
      visible: true,
      label: "NIPPON EXPRESS",
      trackCarrier: "NEX",
      value: "N1"
    },
    {
      isActived: true,
      visible: true,
      label: "NISSIN CORPORATION",
      trackCarrier: "NISS",
      value: "N2"
    },
    {
      isActived: true,
      visible: true,
      label: "PANALPINA",
      trackCarrier: "PAN",
      value: "P1"
    },
    {
      isActived: true,
      visible: true,
      label: "TOLL GROUP",
      trackCarrier: "TOLL",
      value: "T1"
    },
    {
      isActived: true,
      visible: true,
      label: "UPS (COURIER)",
      trackCarrier: "UPSC",
      value: "U1"
    },
    {
      isActived: true,
      visible: true,
      label: "UPS (FREIGHT)",
      trackCarrier: "UPSF",
      value: "U2"
    },
    {
      isActived: true,
      visible: true,
      label: "VANGUARD MEDICAL LOGISTICS",
      trackCarrier: "VML",
      value: "V1"
    },
    {
      isActived: true,
      visible: true,
      label: "YUSEN LOGISTICS",
      trackCarrier: "YUS",
      value: "Y1"
    }
  ]
}; 